import type { Product } from '../types/domain';
/** Convert an entered (unit,qty) into base units using the product's factor. */
export const toBaseQty = (
  product: Product,
  unitName: string,
  qty: number,
): number => {
  const u = product.units.find((x) => x.unit === unitName) ?? product.units[0];
  return qty * (u?.factor ?? 1);
};

/** Exact scanner identity includes every active alias of the selected unit. */
export const unitMatchesBarcode = (
  unit: Product['units'][number],
  barcode: string,
): boolean =>
  unit.barcode === barcode.trim() ||
  unit.barcodeAliases?.includes(barcode.trim()) === true;
